module.exports = __webpack_public_path__ + "static/media/hincome_new.27507b64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hincome_new.jpg
// module id = 1930
// module chunks = 0